import { IUser } from '@shared/models/iuser.model';
import { userGroupEnum } from '@shared/resolvers/user-info.resolver';
import { UserLocaleService } from '@core/services/user-locale.service';
import { CountryId } from '@shared/models/country.model';

const userLocaleService = new UserLocaleService();
const NETHERLANDS_VAS_LOB_SKEY = 125;

/**
 * Returns a function that evaluates if a given user contains a given user group
 * @param targetGroup
 * @returns
 */
export const hasUserGroup =
  (targetGroup: userGroupEnum) =>
  (user: IUser): boolean =>
    (user.groups ?? []).some(group => group.value === targetGroup);

/**
 * Returns whether a given user has QC Team group
 */
export const hasQCTeamGroup = hasUserGroup(userGroupEnum.QC_TEAM);

/**
 * Returns whether a given user has VAS Approver group
 */
export const hasVASApproverGroup = hasUserGroup(userGroupEnum.VAS_APPROVER);

/**
 * Returns whether a given user is based in a CE (Central Europe) country
 */
export const isCEUser = (user: IUser): boolean => userLocaleService.isEURCEUser(user.userCountrySkey);

export const isCENotVASApprover = (user: IUser): boolean => isCEUser(user) && !hasVASApproverGroup(user);

export const isNetherlandsVASUser = (user: IUser): boolean =>
  user.userCountrySkey === CountryId.Netherlands && user.userLobSkey === NETHERLANDS_VAS_LOB_SKEY;

export const enum vasApprovalFlag {
  verified = 'Verified',
  rejected = 'Rejected',
  toBeVerified = 'To Be Verified',
}
